import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import { TabName } from '../terminal-discovery.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    discoveredCount: { default: 0 },
    subnetCount: { default: 0 },
    ignoredCount: { default: 0 },
    hasPermission: { type: Boolean, default: true }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emit = __emit

const STAT_CARD_KEYS: TabName[] = [TabName.discovered, TabName.subnet, TabName.ignored]

const statisticsItems = computed(() => {
  const can = props.hasPermission
  return [
    {
      label: t('terminalDiscovery.statDiscovered'),
      value: props.discoveredCount,
      span: 8,
      clickable: can && props.discoveredCount > 0
    },
    {
      label: t('terminalDiscovery.statSubnetCount'),
      value: props.subnetCount,
      span: 8,
      clickable: can && props.subnetCount > 0
    },
    {
      label: t('terminalDiscovery.statIgnored'),
      value: props.ignoredCount,
      span: 8,
      clickable: can && props.ignoredCount > 0
    }
  ]
})

function onItemClick(index: number) {
  const key = STAT_CARD_KEYS[index]
  if (key) emit('statClick', key)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, {
    items: statisticsItems.value,
    onItemClick: onItemClick
  }, null, 8, ["items"]))
}
}

})